import React from "react";
import PropTypes from "prop-types";
import Link from "next/link";
import buildImageURI from "utils/buildImageURI";

import LazyImage from "../LazyImage";
import FinancingData from "../FinancingData";
import FinancingDetailsOverlay from "../FinancingDetailsOverlay";
import withObjectFitSupportDetection from "../../hocs/withObjectFitSupportDetection";
import preventDefaultAction from "../../utils/preventDefaultAction";

const ModelOfferCard = ({
  imagePath,
  pageUrl,
  title,
  subtitle,
  minLeasingRate,
  hasOffers = true,
  cheapestProduct,
}) => {
  const imageURI = buildImageURI(imagePath);

  return (
    <Link href={pageUrl}>
      <a className="model-offer-card">
        <div className="model-offer-card__wrapper">
          <div className={`model-offer-card__image ${!hasOffers ? "opacity-30" : ""}`}>
            <LazyImage
              src={imageURI}
              alt={title}
              height={100}
              width={150}
              layout="fixed"
            />
          </div>

          <div className="model-offer-card__text">
            <div className="sm:mb-4 pr-2 max-w-full">
              <p className="text-lg font-bold leading-tight">{title}</p>
              {subtitle && (
                <p className="text-sm text-grey-darker leading-tight">
                  {subtitle}
                </p>
              )}
            </div>
            {hasOffers ? (
              <div className="text-right sm:text-left">
                <div className="sm:mt-auto btn btn--primary">
                  {`ab ${minLeasingRate}/mtl.`}
                </div>
                {/* The <div> element has a child <button> element that allows keyboard interaction */}
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
                <div
                  className="paragraph--extra-small pt-2"
                  onClick={e => preventDefaultAction(e)}
                >
                  <FinancingDetailsOverlay
                    title={cheapestProduct.title}
                    financingData={<FinancingData {...cheapestProduct} />}
                  />
                </div>
              </div>
            ) : (
              <p className="sm:mt-auto btn py-1 leading-tight">
                Aktuell nicht
                <br />
                {" "}
                verfügbar
              </p>
            )}
          </div>
        </div>
      </a>
    </Link>
  );
};

ModelOfferCard.propTypes = {
  imagePath: PropTypes.string,
  pageUrl: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  minLeasingRate: PropTypes.string,
};

export default withObjectFitSupportDetection(ModelOfferCard);
